import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function ProofSection() {
  return <section className="py-20 px-6 bg-terracotta/10 my-16" data-id="element-104">
      <div className="max-w-3xl mx-auto text-center" data-id="element-105">
        <FadeIn data-id="element-106">
          <h3 className="text-sm font-sans font-bold tracking-widest text-terracotta uppercase mb-4" data-id="element-107">
            Believability
          </h3>
          <h2 className="font-serif text-3xl md:text-4xl text-charcoal mb-8 leading-tight" data-id="element-108">
            The 72-Hour Snapshot
          </h2>

          <p className="text-lg md:text-xl text-charcoal-light font-serif italic leading-relaxed mb-8" data-id="element-109">
            "Within the first 24 hours, most users report a significant increase
            in urination (the 'Flush') and a noticeable softening of the
            abdominal wall. By the 48-hour mark, the 'waistband pinch' typically
            disappears as the internal inflammation subsides."
          </p>
        </FadeIn>
      </div>
    </section>;
}